// extracted by mini-css-extract-plugin
export default {"warpper":"transferCenter_warpper__4Gh36","list":"transferCenter_list__dJ+7T","transfer":"transferCenter_transfer__KxZ8u"};